var trialAfterBreak, inBreakTrial = false, currentBreakTrial = -1, breakStartTimestamp = startTimestamp;

function startBreakTimestamp(){
    breakStartTimestamp = (new Date()).getTime();
    window.breakTimerWaitForStartCall = false;
    window.timerStartThisTrial = false;
}

function precomputeBreakTrial(trial){
    var breakRegex = /([0-9]+)([m|s])?([0-9]+s)?/gm;
    var content = columnForTrial('break', trial);
    if(content == "na"){
        return 0;
    }

    var matches = breakRegex.exec(content);
    if(matches){
        var minutes, seconds, breakOptions = {'row': trial};
        //minutes and seconds
        if(matches[3] != undefined){
            minutes = parseInt(matches[1]);
            seconds = parseInt(matches[3]);
            breakOptions.seconds = minutes * 60 + seconds;
        }
        //minutes or seconds
        else if(matches[2] != undefined){
            if(matches[2] == 'm'){
                minutes = parseInt(matches[1]);
                breakOptions.seconds = minutes * 60;
            }
            else{
                seconds = parseInt(matches[1]);
                breakOptions.seconds = seconds;
            }
        }
        else if(matches[1]!= undefined){
            breakOptions.trials = parseInt(matches[1]);
        }
        else{
            return 0;
        }
        insertBreakIntoQueues(breakOptions);
        return breakOptions;
    }
    return 0;
}

function getNextBreak(){
    if(window.breakTimerWaitForStartCall === undefined){
        window.breakTimerWaitForStartCall = false;
    }

    if(window.timerStartThisTrial === undefined){
        window.timerStartThisTrial = true;
    }

    if(window.inBreakTrial){
        return undefined;
    }
    var nextBreak, secondsElapsed = ((new Date()).getTime() - breakStartTimestamp) / 1000;
    if(breakQueueTime[0] && secondsElapsed > breakQueueTime[0].seconds && window.breakTimerWaitForStartCall === false && timerStartThisTrial === true){
        nextBreak = breakQueueTime[0];
        breakQueueTime.shift();
    }
    else if(breakQueueTrials[0] && window.elapsedTrials >= breakQueueTrials[0].trials){
        nextBreak = breakQueueTrials[0];
        breakQueueTrials.shift();
    }

    //Timer for break was started this trial, after this is break is reached we can presented
    if(timerStartThisTrial === false){
        timerStartThisTrial = true;
    }
    return nextBreak;
}

function insertBreakIntoQueues(options){
    if(window.inPreviewMode) {
        return;
    }

    if(options.seconds){
        for(var i = 0; i < window.breakQueueTime.length; i++){
            if(options.seconds < window.breakQueueTime[i].seconds){
                window.breakQueueTime.splice(i, 0, options);
                return;
            }
        }
        window.breakQueueTime.push(options);
    }
    else if(options.trials){
        for(var i = 0; i < window.breakQueueTrials.length; i++){
            if(options.trials < window.breakQueueTrials[i].trials){
                window.breakQueueTrials.splice(i, 0, options);
                return;
            }
        }
        window.breakQueueTrials.push(options);
    }
}

function filterBreaksBySubjectGroup() {
    if (window.pickedSubjectGroups.length > 0) {
        filterBreakArrayBySubjectGroup(window.pickedSubjectGroups, window.breakQueueTime);
        filterBreakArrayBySubjectGroup(window.pickedSubjectGroups, window.breakQueueTrials);
    }

    function filterBreakArrayBySubjectGroup(pickedSubjectGroups, breakArray) {
        for(var i = 0; i < breakArray.length; i++){
            const currentBreak = breakArray[i];
            var breakSubjectGroup = window.columnForTrial('subjectGroup', currentBreak.row).trim();
            if (breakSubjectGroup !== "0" && parseInt(breakSubjectGroup) == breakSubjectGroup) {
                breakSubjectGroup = 'nsg:' + breakSubjectGroup;
            }

            if(breakSubjectGroup !== "na" && breakSubjectGroup !== "0" && !pickedSubjectGroups.includes(breakSubjectGroup)) {
                breakArray.splice(i, 1);
                i--;
            }
        }
    }
}

function startBreak(breakTrialRow){
    var breakTrial = window.stimOrder.indexOf(breakTrialRow);
    if(breakTrial < 0) {
        //break is not in bounds because of randomization/subjectGroups
        return;
    }

    window.trialAfterBreak = window.trial;
    if(window.isBreakTrial(window.trial)){
        window.trialAfterBreak++;
    }

    window.inBreakTrial = true;
    window.trial = breakTrial;
    window.currentBreakTrial = breakTrial;
    window.trialRow = window.stimOrder[window.trial];
}

function breakTrialHasLogic(breakTrialRow){
    if(window.columnForTrial('then', breakTrialRow) !== "na"){
        return true;
    }
    return false;
}

function isBreakTrial(trial){
    if(listTrialBreak[trial]!=undefined && listTrialBreak[trial] != 0){
        return true;
    }
    return false;
}

function jumpOverBreakTrial(){
    if (window.inPreviewMode) {
        return;
    }
    // check if break of trialRow because trial is just the number of the current displayed/skipped trial counter
    while(isBreakTrial(window.trialRow)){
        window.trial = window.trial + 1;
        window.trialRow = window.stimOrder[window.trial];
    }
}

function endBreak(){
    if(breakTrialHasLogic(window.stimOrder[window.currentBreakTrial])){
        var trialAfterLogic = window.getNextTrialRowNumber(window.currentBreakTrial, window.stimOrder[window.currentBreakTrial]);
        if(window.stimOrder[window.currentBreakTrial] !== trialAfterLogic) {
            window.trialAfterBreak = window.stimOrder.indexOf(trialAfterLogic);
        }
    }

    window.inBreakTrial = false;
    window.trial = window.trialAfterBreak;
    window.trialRow = window.stimOrder[window.trial];
}

